// API для массовых операций модерации.
// Негізгі жол — POST /api/v1/admin/announcements/bulk-status (бір сұраныс).
// Бэкендте ол әлі жоқ болса (404/405) — әр хабарландыруға
// PATCH /api/v1/admin/announcement/{id} шақырылады (status.js).
import { API_URL } from "../../config/connect";
import { acceptAdById, rejectAdById } from "../status";

const CONCURRENCY = 10;

/** fn-ді әр id үшін CONCURRENCY параллельмен шақырады.
 * Нәтиже: { done: [id...], failed: [{ id, error }] }. */
const runEach = async (adIds, fn) => {
  const done = [];
  const failed = [];
  let next = 0;

  const worker = async () => {
    while (next < adIds.length) {
      const id = adIds[next++];
      try {
        await fn(id);
        done.push(id);
      } catch (error) {
        failed.push({ id, error: error.message });
      }
    }
  };

  await Promise.all(Array.from({ length: Math.min(CONCURRENCY, adIds.length) }, worker));
  return { done, failed };
};

/** Бір сұраныспен статус өзгерту. Эндпоинт жоқ болса null қайтарады. */
const postBulkStatus = async (adIds, status, rejectMessage) => {
  const response = await fetch(`${API_URL}/api/v1/admin/announcements/bulk-status`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("google_id_token")}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: adIds, status, reject_message: rejectMessage ?? null }),
  });

  if (response.status === 404 || response.status === 405) return null;
  if (!response.ok) {
    let detail = "";
    try {
      const body = await response.json();
      detail = typeof body?.detail === "string" ? body.detail : JSON.stringify(body?.detail ?? body);
    } catch (_) {
      /* JSON емес жауап */
    }
    throw new Error(`Bulk status failed (${response.status})${detail ? `: ${detail}` : ""}`);
  }
  return response.json();
};

const bulkAccept = async (adIds) =>
  (await postBulkStatus(adIds, "active")) ?? runEach(adIds, acceptAdById);

const bulkReject = async (adIds, reason) =>
  (await postBulkStatus(adIds, "rejected", reason)) ?? runEach(adIds, (id) => rejectAdById(id, reason));

// Админге хабарландыруды өшіретін эндпоинт бэкендте жоқ.
const bulkDelete = async () => {
  throw new Error("Удаление объявлений не поддерживается бэкендом");
};

export { bulkAccept, bulkReject, bulkDelete };
